<template>
  <TransitionGroup class="elements" name="fade" tag="div">
    <DialogStreakCountDay
      v-for="(unit, index) in unitsUsed"
      :key="index"
      :index="index"
      :current-index="unitIndex"
      :final-value="unit"
      :delay="index * 400"
      @complete="handleCompleteIndex"
    />
  </TransitionGroup>
</template>

<script setup lang="ts">
interface Props {
  dayCount: number;
}

const props = defineProps({
  dayCount: null
});

const unitIndex = ref(0);

const units = computed(() => {
  return `${props.dayCount}`
    .split('')
    .map((v) => parseInt(v))
    .reverse();
});

const unitsUsed = computed(() => {
  return units.value.slice(0, unitIndex.value + 1);
});

const handleCompleteIndex = (index: number) => {
  unitIndex.value = index += 1;
};
</script>

<style lang="scss" scoped>
.elements {
  display: flex;
  flex-direction: row-reverse;
}

/* 1. declare transition */
.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: all 300ms $ease-out-quad;
}

/* 2. declare enter from and leave to state */
.fade-enter-from,
.fade-leave-to {
  transform: all 300ms $ease-out-quad;
  opacity: 0;
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-leave-active {
  position: absolute;
}
</style>
